import React from 'react';
import { DivHeader } from './styles';
import { fieldsPropType } from './PropTypes';

function HeaderComponent({ fields }) {
  return (
    <>
      <DivHeader area="payer">
        {fields.payer.label}
      </DivHeader>
      <DivHeader area="contract">
        {fields.contract.label}
      </DivHeader>

      <DivHeader area="payment_notes">
        {fields.payment_notes.label}
      </DivHeader>

      <DivHeader area="payment_number">
        № рядку
      </DivHeader>
      <DivHeader area="order_amount">
        {fields.order_amount.label}
      </DivHeader>
      <DivHeader area="revenue_amount">
        {fields.revenue_amount.label}
      </DivHeader>
      <DivHeader area="warning">
        Відповідає
      </DivHeader>
    </>
  );
}

HeaderComponent.propTypes = {
  fields: fieldsPropType,
};

HeaderComponent.defaultProps = {
  fields: {},
};
export default HeaderComponent;
